import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { triggerPasswordChangeEmail } from 'actions/authentication';
import Button from 'atoms/button';
import Input from 'atoms/input';

export default function PasswordResetBlock() {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [emailSent, setEmailSent] = useState(false);

  const onResetPassword = (e) => {
    e.preventDefault();
    dispatch(triggerPasswordChangeEmail({ email })).then(({ success }) => {
      if (success) setEmailSent(true);
    });
  };

  return (
    <div className="login">
      {!emailSent ? (
        <>
          <h1>Forgot password?</h1>
          <form onSubmit={onResetPassword}>
            <Input
              id="email"
              label="Email"
              onChange={(value) => setEmail(value)}
              value={email}
            />
            <span className="no-account-text">
              Don&apos;t have an account?
              <Link to="/signup">Sign up.</Link>
            </span>
            <Button type="submit" text="Reset password" />
          </form>
        </>
      ) : (
        <>
          <h1 className="mb-10">Password reset</h1>
          <p>
            Check your email for a password reset link.{' '}
            <span
              className="c-primary-orange pointer"
              onClick={onResetPassword}
            >
              Resend email
            </span>
            .
          </p>
        </>
      )}
    </div>
  );
}
